import { Header, Icon, Label } from '@mairistem/composants';
import { ListeTable } from '@mairistem/liste';
import dayjs from 'dayjs';
import { useEcheances } from '@/hooks';
import type { BordereauType } from '@/types';
import { formatMonetaire, getRegieRegisseurFullName, isBordereauTitrageAFaire } from '@/utils';

interface BordereauCarteBancaireInternetListeTableRowProps {
  item: BordereauType;
  rowProps: Record<string, unknown>;
  onPrintDocument?: (identifiant: number) => void;
}

const BordereauCarteBancaireInternetListeTableRow = (
  props: BordereauCarteBancaireInternetListeTableRowProps,
) => {
  const { item, rowProps, onPrintDocument } = props;

  const { identifiant, numero, montantTotal, dateRemise, regisseur } = item;

  const { echeanceArrete } = useEcheances();
  const titrageAFaire = isBordereauTitrageAFaire(item, echeanceArrete?.date);

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell name="numero" style={{ width: 150 }} textAlign="right">
        {numero}
      </ListeTable.Cell>
      <ListeTable.Cell name="montantTotal" textAlign="right" style={{ width: 140 }}>
        {formatMonetaire(montantTotal)}
      </ListeTable.Cell>
      <ListeTable.Cell name="dateRemise" textAlign="center" style={{ width: 140 }}>
        {dayjs(dateRemise).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell name="regisseur">{getRegieRegisseurFullName(regisseur)}</ListeTable.Cell>
      <ListeTable.Cell name="titrage" style={{ width: 150 }}>
        {titrageAFaire && (
          <Label size="small" circular color="orange" style={{ width: '100%' }}>
            <Header as="h5" style={{ margin: 0 }} color="orange">
              A faire
            </Header>
          </Label>
        )}
      </ListeTable.Cell>
      <ListeTable.Cell name="document" textAlign="center" style={{ width: 100 }}>
        <Icon
          name="file pdf"
          link
          title="Voir le document"
          onClick={() => onPrintDocument?.(identifiant)}
          size="large"
        />
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default BordereauCarteBancaireInternetListeTableRow;
